import { varchar } from 'drizzle-orm/pg-core';
export function colorVariantColumn() {
    return varchar('color', { length: 15 }).notNull().default('purple').$type();
}
//# sourceMappingURL=columns.js.map